// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"dividers-1"},"nodeName":"g","children":[{"attributes":{"id":"fill2","fill":"transparent","d":"M15.4275 8.73669C15.4275 10.5679 13.8931 12.0525 12.0004 12.0525C10.1076 12.0525 8.57324 10.5679 8.57324 8.73669C8.57324 6.90543 10.1076 5.4209 12.0004 5.4209C13.8931 5.4209 15.4275 6.90543 15.4275 8.73669Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M12.0004 5.42105C10.1076 5.42105 8.57325 6.90558 8.57325 8.73684C8.57325 10.5681 10.1076 12.0526 12.0004 12.0526C13.8931 12.0526 15.4275 10.5681 15.4275 8.73684C15.4275 6.90558 13.8931 5.42105 12.0004 5.42105ZM12.0004 5.42105V2M20.3022 16.3018C15.0428 18.6998 8.95772 18.6998 3.69824 16.3018M9.57037 11.075L4.00367 22H4.00024L9.57037 11.075ZM14.4301 11.075L19.9968 22H20.0002L14.4301 11.075Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-dividers-1')
export default class Dividers1Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'dividers-1',
    }
  }
}
